import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2';
import { DOUGHNUT_CHART_COLOR } from '../model/ChartColor';
import styled from 'styled-components';
import { DR_CHART_LABEL } from '../model/chartLabel';
import { withTranslation } from 'react-i18next';

class DoughnutChart extends Component {
  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      data: {
        labels: [
          t(DR_CHART_LABEL.predicted),
          t(DR_CHART_LABEL.run),
          t(DR_CHART_LABEL.all),
        ],
        datasets: [{
          data: [300, 50, 100],
          backgroundColor: [
            DOUGHNUT_CHART_COLOR.GRAY,
            DOUGHNUT_CHART_COLOR.PURPLE,
            DOUGHNUT_CHART_COLOR.BLUE,
          ],
          borderColor: [
            DOUGHNUT_CHART_COLOR.GRAY,
            DOUGHNUT_CHART_COLOR.PURPLE,
            DOUGHNUT_CHART_COLOR.BLUE,
          ],
        }],
        borderWidth: 0
      },
      options: {
        legend: {
          display: false
        },
        responsive: true,        // 반응형 설정
        maintainAspectRatio: false,  // 비율 유지 비활성화
      }
    }

    this.setGraphData = this.setGraphData.bind(this);
  }

  setGraphData(data) {
    return {
      labels: [
        DR_CHART_LABEL.predicted,
        DR_CHART_LABEL.run, 
        DR_CHART_LABEL.all, 
      ],
      datasets: [{
        data,
        backgroundColor: [
          DOUGHNUT_CHART_COLOR.GRAY,
          DOUGHNUT_CHART_COLOR.PURPLE,
          DOUGHNUT_CHART_COLOR.BLUE,
        ],
        borderColor: [
          DOUGHNUT_CHART_COLOR.GRAY,
          DOUGHNUT_CHART_COLOR.PURPLE,
          DOUGHNUT_CHART_COLOR.BLUE,
        ],
      }],
      borderWidth: 0
    }
  }
  render() {
    const { options } = this.state;
    const { data, t } = this.props;
    return (
      <Container>
        <DoughnutWrapper>
          <Doughnut data={this.setGraphData(data)} options={options}/>
        </DoughnutWrapper>
        <LabelWrapper>
          <Label color={DOUGHNUT_CHART_COLOR.BLUE}>
            <span></span>
            <span>{t(DR_CHART_LABEL.all)}</span>
          </Label>
          <Label color={DOUGHNUT_CHART_COLOR.PURPLE}>
            <span></span>
            <span>{t(DR_CHART_LABEL.run)}</span>
          </Label>
          {/* <Label color={DOUGHNUT_CHART_COLOR.GRAY}>
            <span></span>
            <span>{DR_CHART_LABEL.predicted}</span>
          </Label> */}
        </LabelWrapper>
      </Container>
    );
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;

`;

const DoughnutWrapper = styled.div`
  width: 126px;
  height: 126px;
`;

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Label = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  font-weight: 400;

  & > span:first-child {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 3px;
    background-color: ${({ color }) => color};
  }
  & > span:last-child {
    margin-left: 10px;
    line-height: 24px;
  }
`;

export default withTranslation()(DoughnutChart);